import numeral from 'numeral';

export function moneyfiltro(value) {
  if (value === null || value === undefined || isNaN(value)) {
    return 'S/ 0.00';
  }
  return 'S/ ' + numeral(value).format('0,0.00');
}

export function currencyFilter(value, currency = 'PEN', decimals = 2) {
  if (value === null || value === undefined || isNaN(value)) {
    return 'S/ 0.00';
  }
  const prefix = currency === 'PEN' ? 'S/ ' : '$ ';
  const formatStr = '0,0.' + '0'.repeat(decimals);
  return prefix + numeral(value).format(formatStr);
}
